module.exports = "/static/assets/fb735d3c52484dfdc864f4066e212ad7.png";